import { Link } from "react-router-dom";

interface RequestCardProps {
  title: string;
  btnTitle: string;
  imagePath: string;
  redirectionPath: string;
}

const RequestCard: React.FC<RequestCardProps> = ({
  title,
  btnTitle,
  imagePath,
  redirectionPath,
}) => {
  return (
    <div className="w-full flex p-4 bg-primary rounded-tl-3xl rounded-br-3xl">
      <div className="w-full lg:w-3/5 flex flex-col justify-between text-white font-semibold p-4 gap-3">
        <h2 className="text-4xl font-bold p-2"> {title} </h2>
        <Link
          to={redirectionPath}
          className="mx-2 p-2 border-2 border-white rounded hover:opacity-50 text-center"
        >
          {btnTitle}
        </Link>
      </div>
      <img
        src={imagePath}
        alt={btnTitle}
        className="w-2/5 p-2 object-contain border border-white rounded-3xl portrait-hidden landscape-flex lg:block"
      />
    </div>
  );
};

export default RequestCard;
